import { tokensAtom } from "../../jotai/atoms";
import { globalStore } from "../../jotai/store";
import { Tokens } from "../../models/Interfaces";

export default async (tokens: Tokens) => {
  await globalStore.set(tokensAtom, tokens);
};
